import { FC } from 'react';

import numeral from 'numeral';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import Text, { TextImportance } from 'bloko/blocks/text';

interface AmountProps {
    amount: number | null;
    correctedAmount: number | null;
}

const Amount: FC<AmountProps> = ({ amount, correctedAmount }) => {
    if (correctedAmount !== null) {
        return (
            <>
                <Text Element="span">{numeral(correctedAmount).format('0,0.00')}</Text>
                <Text Element="span" importance={TextImportance.Tertiary}>
                    {`${NON_BREAKING_SPACE}(${numeral(amount).format('0,0.00')})`}
                </Text>
            </>
        );
    }

    return <Text Element="span">{numeral(amount).format('0,0.00')}</Text>;
};

export default Amount;
